import React, { useState, useEffect } from "react";
import Menubar from "../Menubar/Menubar";
import { Outlet, useNavigate } from "react-router-dom";
import "../Dashboard/Dashboard.css";
import { Tooltip } from "antd";
import { MdKeyboardDoubleArrowLeft } from "react-icons/md";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import { FaEye, FaEdit } from "react-icons/fa";
// import { FaDownload } from "react-icons/fa6";
import { MdDelete } from "react-icons/md";
import { MdHolidayVillage } from "react-icons/md";
import { FaHotel } from "react-icons/fa6";
import { CgTemplate } from "react-icons/cg";
import { FaSpinner } from "react-icons/fa";

const PropertyBrochure = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
  // const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 1024);
  const [deletingId, setDeletingId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedBrochure, setSelectedBrochure] = useState(null);

  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
    const savedState = localStorage.getItem("menubarOpen");

    if (savedState !== null) {
      return JSON.parse(savedState);
    }

    return window.innerWidth >= 1024;
  });
  const [brochures, setBrochures] = useState([]);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 1024;
      setIsMobile(mobile);

      if (mobile) {
        setIsSidebarOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    fetchBrochures();
  }, []);
  useEffect(() => {
    setCurrentPage_brochureVilla(1);
    setCurrentPage_brochureHotel(1);
  }, [searchQuery]);
  const fetchBrochures = async () => {
    try {
      const res = await fetch(
        "https://demo.zorbastays.com/web-backend/getBrochures",
      );
      const data = await res.json();

      if (data.success) {
        setBrochures(data.data);
      }
    } catch (err) {
      console.error("Error fetching brochures:", err);
    }
  };
  // const navigate = useNavigate();

  const [active, setActive] = useState("Villas");

  const options = ["Villas", "Hotels"];
  // const options = ["Villas"];
  // const table_brochureVilla = [
  //   {
  //     channel: "Alice Wilson",
  //     order: "ORD-1001",
  //     date: "05-02-2025",
  //     productName: "Wxyz",
  //     payment: "149.99",
  //     method: "Pre-Paid",
  //     customer: "John Doe",
  //     awb: "AWB-5001",
  //     status: "PENDING",
  //   },
  //   {
  //     channel: "Alice Wilson",
  //     order: "ORD-1002",
  //     date: "04-02-2025",
  //     productName: "Abcd",
  //     payment: "179.99",
  //     method: "COD",
  //     customer: "Jane Smith",
  //     awb: "AWB-5002",
  //     status: "BOOKED",
  //   },
  //   {
  //     channel: "Alice Wilson",
  //     order: "ORD-1003",
  //     date: "03-02-2025",
  //     productName: "Efgh",
  //     payment: "129.99",
  //     method: "Pre-Paid",
  //     customer: "Alice Brown",
  //     awb: "AWB-5003",
  //     status: "CANCELLED",
  //   },
  //   {
  //     channel: "Alice Wilson",
  //     order: "ORD-1004",
  //     date: "02-02-2025",
  //     productName: "Ijkl",
  //     payment: "1109.99",
  //     method: "COD",
  //     customer: "Bob Johnson",
  //     awb: "AWB-5004",
  //     status: "FAILED",
  //   },
  //   {
  //     channel: "Alice Wilson",
  //     order: "ORD-1005",
  //     date: "01-02-2025",
  //     productName: "Mnop",
  //     payment: "159.99",
  //     method: "Pre-Paid",
  //     customer: "Charlie Wilson",
  //     awb: "AWB-5005",
  //     status: "CONFIRMED",
  //   },
  //   {
  //     channel: "Alice Wilson",
  //     order: "ORD-1001",
  //     date: "05-02-2025",
  //     productName: "Wxyz",
  //     payment: "149.99",
  //     method: "COD",
  //     customer: "John Doe",
  //     awb: "AWB-5001",
  //     status: "PENDING",
  //   },
  //   {
  //     channel: "Alice Wilson",
  //     order: "ORD-1002",
  //     date: "04-02-2025",
  //     productName: "Abcd",
  //     payment: "179.99",
  //     method: "Pre-Paid",
  //     customer: "Jane Smith",
  //     awb: "AWB-5002",
  //     status: "BOOKED",
  //   },
  //   {
  //     channel: "Alice Wilson",
  //     order: "ORD-1003",
  //     date: "03-02-2025",
  //     productName: "Efgh",
  //     payment: "129.99",
  //     method: "COD",
  //     customer: "Alice Brown",
  //     awb: "AWB-5003",
  //     status: "CANCELLED",
  //   },
  //   {
  //     channel: "Alice Wilson",
  //     order: "ORD-1004",
  //     date: "02-02-2025",
  //     productName: "Ijkl",
  //     payment: "1109.99",
  //     method: "Pre-Paid",
  //     customer: "Bob Johnson",
  //     awb: "AWB-5004",
  //     status: "FAILED",
  //   },
  //   {
  //     channel: "Alice Wilson",
  //     order: "ORD-1005",
  //     date: "01-02-2025",
  //     productName: "Mnop",
  //     payment: "159.99",
  //     method: "COD",
  //     customer: "Charlie Wilson",
  //     awb: "AWB-5005",
  //     status: "CONFIRMED",
  //   },
  //   {
  //     channel: "Alice Wilson",
  //     order: "ORD-1001",
  //     date: "05-02-2025",
  //     productName: "Wxyz",
  //     payment: "149.99",
  //     method: "Pre-Paid",
  //     customer: "John Doe",
  //     awb: "AWB-5001",
  //     status: "PENDING",
  //   },
  //   {
  //     channel: "Alice Wilson",
  //     order: "ORD-1002",
  //     date: "04-02-2025",
  //     productName: "Abcd",
  //     payment: "179.99",
  //     method: "COD",
  //     customer: "Jane Smith",
  //     awb: "AWB-5002",
  //     status: "BOOKED",
  //   },
  //   {
  //     channel: "Alice Wilson",
  //     order: "ORD-1003",
  //     date: "03-02-2025",
  //     productName: "Efgh",
  //     payment: "129.99",
  //     method: "Pre-Paid",
  //     customer: "Alice Brown",
  //     awb: "AWB-5003",
  //     status: "CANCELLED",
  //   },
  //   {
  //     channel: "Alice Wilson",
  //     order: "ORD-1004",
  //     date: "02-02-2025",
  //     productName: "Ijkl",
  //     payment: "1109.99",
  //     method: "COD",
  //     customer: "Bob Johnson",
  //     awb: "AWB-5004",
  //     status: "FAILED",
  //   },
  //   {
  //     channel: "Alice Wilson",
  //     order: "ORD-1005",
  //     date: "01-02-2025",
  //     productName: "Mnop",
  //     payment: "159.99",
  //     method: "Pre-Paid",
  //     customer: "Charlie Wilson",
  //     awb: "AWB-5005",
  //     status: "CONFIRMED",
  //   },
  //   {
  //     channel: "Alice Wilson",
  //     order: "ORD-1001",
  //     date: "05-02-2025",
  //     productName: "Wxyz",
  //     payment: "149.99",
  //     method: "COD",
  //     customer: "John Doe",
  //     awb: "AWB-5001",
  //     status: "PENDING",
  //   },
  //   {
  //     channel: "Alice Wilson",
  //     order: "ORD-1002",
  //     date: "04-02-2025",
  //     productName: "Abcd",
  //     payment: "179.99",
  //     method: "Pre-Paid",
  //     customer: "Jane Smith",
  //     awb: "AWB-5002",
  //     status: "BOOKED",
  //   },
  //   {
  //     channel: "Alice Wilson",
  //     order: "ORD-1003",
  //     date: "03-02-2025",
  //     productName: "Efgh",
  //     payment: "129.99",
  //     method: "COD",
  //     customer: "Alice Brown",
  //     awb: "AWB-5003",
  //     status: "CANCELLED",
  //   },
  //   {
  //     channel: "Alice Wilson",
  //     order: "ORD-1004",
  //     date: "02-02-2025",
  //     productName: "Ijkl",
  //     payment: "1109.99",
  //     method: "Pre-Paid",
  //     customer: "Bob Johnson",
  //     awb: "AWB-5004",
  //     status: "FAILED",
  //   },
  //   {
  //     channel: "Alice Wilson",
  //     order: "ORD-1005",
  //     date: "01-02-2025",
  //     productName: "Mnop",
  //     payment: "159.99",
  //     method: "COD",
  //     customer: "Charlie Wilson",
  //     awb: "AWB-5005",
  //     status: "CONFIRMED",
  //   },
  //   {
  //     channel: "Alice Wilson",
  //     order: "ORD-1001",
  //     date: "05-02-2025",
  //     productName: "Wxyz",
  //     payment: "149.99",
  //     method: "Pre-Paid",
  //     customer: "John Doe",
  //     awb: "AWB-5001",
  //     status: "PENDING",
  //   },
  //   {
  //     channel: "Alice Wilson",
  //     order: "ORD-1002",
  //     date: "04-02-2025",
  //     productName: "Abcd",
  //     payment: "179.99",
  //     method: "COD",
  //     customer: "Jane Smith",
  //     awb: "AWB-5002",
  //     status: "BOOKED",
  //   },
  //   {
  //     channel: "Alice Wilson",
  //     order: "ORD-1003",
  //     date: "03-02-2025",
  //     productName: "Efgh",
  //     payment: "129.99",
  //     method: "Pre-Paid",
  //     customer: "Alice Brown",
  //     awb: "AWB-5003",
  //     status: "CANCELLED",
  //   },
  //   {
  //     channel: "Alice Wilson",
  //     order: "ORD-1004",
  //     date: "02-02-2025",
  //     productName: "Ijkl",
  //     payment: "1109.99",
  //     method: "COD",
  //     customer: "Bob Johnson",
  //     awb: "AWB-5004",
  //     status: "FAILED",
  //   },
  // ];

  const rowsPerPage_brochureVilla = 20;
  const [currentPage_brochureVilla, setCurrentPage_brochureVilla] = useState(1);

  const indexOfLastTable_brochureVilla =
    currentPage_brochureVilla * rowsPerPage_brochureVilla;
  const indexOfFirstTable_brochureVilla =
    indexOfLastTable_brochureVilla - rowsPerPage_brochureVilla;

  const filteredBrochures = searchQuery.trim()
    ? brochures.filter((b) =>
        b.villa_name?.toLowerCase().includes(searchQuery.toLowerCase()),
      )
    : brochures;

  const totalPages_brochureVilla = Math.ceil(
    filteredBrochures.length / rowsPerPage_brochureVilla,
  );
  const current_brochureVilla = filteredBrochures.slice(
    indexOfFirstTable_brochureVilla,
    indexOfLastTable_brochureVilla,
  );
  const handlePageChange_brochureVilla = (pageNumber_brochureVilla) => {
    setCurrentPage_brochureVilla(pageNumber_brochureVilla);
  };

  const handleNextPage_brochureVilla = () => {
    if (currentPage_brochureVilla < totalPages_brochureVilla) {
      setCurrentPage_brochureVilla(currentPage_brochureVilla + 1);
    }
  };

  const handlePrevPage_brochureVilla = () => {
    if (currentPage_brochureVilla > 1) {
      setCurrentPage_brochureVilla(currentPage_brochureVilla - 1);
    }
  };

  const generatePageNumbers_brochureVilla = () => {
    const pageNumbers_brochureVilla = [];

    if (totalPages_brochureVilla <= 3) {
      for (let i = 1; i <= totalPages_brochureVilla; i++) {
        pageNumbers_brochureVilla.push(i);
      }
    } else {
      if (currentPage_brochureVilla > 2) {
        pageNumbers_brochureVilla.push(1);
        pageNumbers_brochureVilla.push("...");
      }
      for (
        let i = currentPage_brochureVilla - 1;
        i <= currentPage_brochureVilla + 1;
        i++
      ) {
        if (i > 0 && i <= totalPages_brochureVilla) {
          pageNumbers_brochureVilla.push(i);
        }
      }
      if (currentPage_brochureVilla < totalPages_brochureVilla - 1) {
        pageNumbers_brochureVilla.push("...");
        pageNumbers_brochureVilla.push(totalPages_brochureVilla);
      }
    }
    return pageNumbers_brochureVilla;
  };

  const [selectedRows_brochureVilla, setSelectedRows_brochureVilla] = useState(
    [],
  );

  const handleRowCheckboxChange_brochureVilla = (order) => {
    setSelectedRows_brochureVilla((prevSelected) =>
      prevSelected.includes(order)
        ? prevSelected.filter((id) => id !== order)
        : [...prevSelected, order],
    );
  };

  const handleSelectAll_brochureVilla = () => {
    if (selectedRows_brochureVilla.length === current_brochureVilla.length) {
      setSelectedRows_brochureVilla([]);
    } else {
      setSelectedRows_brochureVilla(
        current_brochureVilla.map((booking) => booking.order),
      );
    }
  };

  const table_brochureHotel = [
    {
      channel: "Hotel Admin",
      order: "HOT-2001",
      date: "06-02-2025",
      productName: "Hotel Taj",
      payment: "299.99",
      method: "Pre-Paid",
      customer: "Rahul Mehta",
      awb: "AWB-6001",
      status: "CONFIRMED",
    },
    {
      channel: "Hotel Admin",
      order: "HOT-2002",
      date: "07-02-2025",
      productName: "Hotel SeaView",
      payment: "199.99",
      method: "COD",
      customer: "Priya Shah",
      awb: "AWB-6002",
      status: "PENDING",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1005",
      date: "01-02-2025",
      productName: "Mnop",
      payment: "159.99",
      method: "Pre-Paid",
      customer: "Charlie Wilson",
      awb: "AWB-5005",
      status: "CONFIRMED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1001",
      date: "05-02-2025",
      productName: "Wxyz",
      payment: "149.99",
      method: "COD",
      customer: "John Doe",
      awb: "AWB-5001",
      status: "PENDING",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1002",
      date: "04-02-2025",
      productName: "Abcd",
      payment: "179.99",
      method: "Pre-Paid",
      customer: "Jane Smith",
      awb: "AWB-5002",
      status: "BOOKED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1003",
      date: "03-02-2025",
      productName: "Efgh",
      payment: "129.99",
      method: "COD",
      customer: "Alice Brown",
      awb: "AWB-5003",
      status: "CANCELLED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1004",
      date: "02-02-2025",
      productName: "Ijkl",
      payment: "1109.99",
      method: "Pre-Paid",
      customer: "Bob Johnson",
      awb: "AWB-5004",
      status: "FAILED",
    },
    {
      channel: "Alice Wilson",
      order: "ORD-1005",
      date: "01-02-2025",
      productName: "Mnop",
      payment: "159.99",
      method: "COD",
      customer: "Charlie Wilson",
      awb: "AWB-5005",
      status: "CONFIRMED",
    },
  ];

  const rowsPerPage_brochureHotel = 20;
  const [currentPage_brochureHotel, setCurrentPage_brochureHotel] = useState(1);

  const indexOfLastTable_brochureHotel =
    currentPage_brochureHotel * rowsPerPage_brochureHotel;
  const indexOfFirstTable_brochureHotel =
    indexOfLastTable_brochureHotel - rowsPerPage_brochureHotel;

  const current_brochureHotel = table_brochureHotel.slice(
    indexOfFirstTable_brochureHotel,
    indexOfLastTable_brochureHotel,
  );

  const totalPages_brochureHotel = Math.ceil(
    table_brochureHotel.length / rowsPerPage_brochureHotel,
  );

  const handlePageChange_brochureHotel = (pageNumber_brochureHotel) => {
    setCurrentPage_brochureHotel(pageNumber_brochureHotel);
  };

  const handleNextPage_brochureHotel = () => {
    if (currentPage_brochureHotel < totalPages_brochureHotel) {
      setCurrentPage_brochureHotel(currentPage_brochureHotel + 1);
    }
  };

  const handlePrevPage_brochureHotel = () => {
    if (currentPage_brochureHotel > 1) {
      setCurrentPage_brochureHotel(currentPage_brochureHotel - 1);
    }
  };

  const generatePageNumbers_brochureHotel = () => {
    const pageNumbers_brochureHotel = [];

    if (totalPages_brochureHotel <= 3) {
      for (let i = 1; i <= totalPages_brochureHotel; i++) {
        pageNumbers_brochureHotel.push(i);
      }
    } else {
      if (currentPage_brochureHotel > 2) {
        pageNumbers_brochureHotel.push(1);
        pageNumbers_brochureHotel.push("...");
      }
      for (
        let i = currentPage_brochureHotel - 1;
        i <= currentPage_brochureHotel + 1;
        i++
      ) {
        if (i > 0 && i <= totalPages_brochureHotel) {
          pageNumbers_brochureHotel.push(i);
        }
      }
      if (currentPage_brochureHotel < totalPages_brochureHotel - 1) {
        pageNumbers_brochureHotel.push("...");
        pageNumbers_brochureHotel.push(totalPages_brochureHotel);
      }
    }
    return pageNumbers_brochureHotel;
  };

  const [selectedRows_brochureHotel, setSelectedRows_brochureHotel] = useState(
    [],
  );

  const handleRowCheckboxChange_brochureHotel = (order) => {
    setSelectedRows_brochureHotel((prevSelected) =>
      prevSelected.includes(order)
        ? prevSelected.filter((id) => id !== order)
        : [...prevSelected, order],
    );
  };

  const handleSelectAll_brochureHotel = () => {
    if (selectedRows_brochureHotel.length === current_brochureHotel.length) {
      setSelectedRows_brochureHotel([]);
    } else {
      setSelectedRows_brochureHotel(
        current_brochureHotel.map((booking) => booking.order),
      );
    }
  };
  const handleDeleteClick = (item) => {
    setSelectedBrochure(item);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    if (!selectedBrochure) return;

    setDeletingId(selectedBrochure.id);
    setShowDeleteModal(false);

    try {
      const response = await fetch(
        `https://demo.zorbastays.com/web-backend/deleteBrochure/${selectedBrochure.id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      const data = await response.json();

      if (data.success) {
        // Refresh the brochure list
        fetchBrochures(); // Call your existing fetch function
        alert("Brochure deleted successfully!");
      } else {
        alert("Failed to delete brochure: " + data.message);
      }
    } catch (error) {
      console.error("Delete error:", error);
      alert("Error deleting brochure: " + error.message);
    } finally {
      setDeletingId(null);
      setSelectedBrochure(null);
    }
  };

  return (
    <div className="flex bg-[#F8F9FA]">
      <Menubar
        isOpen={isSidebarOpen}
        setIsOpen={setIsSidebarOpen}
        isMobile={isMobile}
      />

      <main
        className={`p-5 lg:p-6 transition-all duration-500 w-full ${
          isMobile ? "ml-0" : isSidebarOpen ? "ml-64" : "ml-16"
        }`}
      >
        <Outlet />

        {/* Header */}
        <div className="flex justify-between gap-5 items-start lg:items-center">
          <div className="flex flex-col lg:flex-row gap-5 items-start lg:items-center">
            <p className="font-semibold text-xl text-gray-700 ml-10 lg:ml-0">
              Property Brochure
            </p>
          </div>

          <div className="flex items-center gap-1">
            <div className="flex items-center">
              <div className="mr-2 p-2 overflow-hidden w-8 h-8 hover:w-[120px] sm:hover:w-[250px] hover:border hover:border-[#1D2826] hover:shadow-[2px_2px_20px_rgba(0,0,0,0.08)] rounded-full flex group items-center hover:duration-300 duration-300">
                <div className="flex items-center justify-center fill-[#1D2826]">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    id="Isolation_Mode"
                    data-name="Isolation Mode"
                    viewBox="0 0 24 24"
                    width="18"
                    height="18"
                  >
                    <path d="M18.9,16.776A10.539,10.539,0,1,0,16.776,18.9l5.1,5.1L24,21.88ZM10.5,18A7.5,7.5,0,1,1,18,10.5,7.507,7.507,0,0,1,10.5,18Z"></path>
                  </svg>
                </div>
                <input
                  type="text"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="Search..."
                  className="border-none outline-none text-sm bg-transparent w-full font-normal px-2 focus:ring-0"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Boxes */}
        <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 items-center gap-5 text-gray-700 font-semibold mt-5">
          <div className="flex items-center justify-between gap-5 bg-[#DAE0CE] py-2 px-4 rounded-lg">
            <div>
              <p className="font-semibold text-sm">Total Brochures</p>
              <p className="my-2 text-lg text-green-500">60</p>
            </div>

            <div>
              <CgTemplate className="bg-[#3C4C4E] text-3xl text-white p-1.5 rounded-md" />
            </div>
          </div>

          <div className="flex items-center justify-between gap-5 bg-[#DAE0CE] py-2 px-4 rounded-lg">
            <div>
              <p className="font-semibold text-sm">Villa Brochures</p>
              <p className="my-2 text-lg text-green-500">55</p>
            </div>

            <div>
              <MdHolidayVillage className="bg-[#3C4C4E] text-3xl text-white p-1.5 rounded-md" />
            </div>
          </div>

          <div className="flex items-center justify-between gap-5 bg-[#DAE0CE] py-2 px-4 rounded-lg">
            <div>
              <p className="font-semibold text-sm">Hotel Brochures</p>
              <p className="my-2 text-lg text-green-500">5</p>
            </div>

            <div>
              <FaHotel className="bg-[#3C4C4E] text-3xl text-white p-1.5 rounded-md" />
            </div>
          </div>
        </div>

        {/* Segmented Buttons */}
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-5 mt-8">
          <div>
            <div className="inline-flex border border-gray-300 rounded-lg overflow-hidden text-sm font-medium shadow-sm">
              {options.map((option) => (
                <button
                  key={option}
                  onClick={() => setActive(option)}
                  className={`px-4 py-2 transition-colors duration-200 focus:outline-none ${
                    active === option
                      ? "bg-[#1D2826] text-white"
                      : "bg-white text-gray-500 hover:bg-green-50"
                  }`}
                >
                  {option}
                </button>
              ))}
            </div>
          </div>

          {/* Button */}
          <div>
            <button
              onClick={() =>
                navigate(
                  active === "Villas"
                    ? "/BrochureElementor"
                    : // : "/PropertyBrochure",
                      "/HotelBrochureElementor",
                )
              }
              className="px-6 z-30 py-2 bg-[#1D2826] rounded-lg text-center text-white relative hover:scale-95 after:-z-20 after:absolute after:h-1 after:w-1 after:bg-green-900 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700 transition-all duration-700 text-sm"
            >
              + Add Brochure
            </button>
          </div>
        </div>

        {/* Table */}
        <div>
          {active === "Villas" && (
            <div className="shadow-md rounded-lg mt-5">
              <div className="overflow-x-auto">
                <table className="w-full text-sm text-left rtl:text-right text-gray-500">
                  <thead className="text-xs text-gray-400 uppercase bg-green-50 border-b">
                    <tr>
                      <th className="p-4">
                        <input
                          type="checkbox"
                          onChange={handleSelectAll_brochureVilla}
                          checked={
                            selectedRows_brochureVilla.length ===
                              current_brochureVilla.length &&
                            current_brochureVilla.length > 0
                          }
                        />
                      </th>
                      <th className="p-4 w-1/10">ID</th>
                      <th className="p-4 w-1/10">Property Name</th>
                      <th className="p-4 w-1/10">Created At</th>
                      <th className="p-4 w-1/10">Updated At</th>
                      {/* <th className="p-4 w-1/10 text-center">
                        Download Brochure
                      </th> */}
                      <th className="p-4 w-1/10 text-center">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {current_brochureVilla.map((item, index) => {
                      return (
                        <tr
                          key={index}
                          className="bg-white even:bg-gray-50 border-b border-gray-200 hover:bg-gray-100 text-gray-800"
                        >
                          <td className="px-4 py-3">
                            <input
                              type="checkbox"
                              onChange={() =>
                                handleRowCheckboxChange_brochureVilla(item.id)
                              }
                              checked={selectedRows_brochureVilla.includes(
                                item.id,
                              )}
                            />
                          </td>
                          <td className="px-4 py-3">
                            <Tooltip title={item.id}>{item.id}</Tooltip>
                          </td>
                          <td className="px-4 py-3">
                            <Tooltip title={item.villa_name}>
                              {item.villa_name}
                            </Tooltip>
                          </td>
                          <td className="px-4 py-3">
                            {new Date(item.created_at).toLocaleDateString()}
                          </td>
                          <td className="px-4 py-3">
                            {new Date(item.created_at).toLocaleDateString()}
                          </td>
                          {/* <td className="px-4 py-3 flex justify-center">
                            <button
                              onClick={() => {
                                const newWindow = window.open(
                                  `/BrochurePDF/${item.id}`,
                                  "_blank",
                                );
                                newWindow.onload = () => {
                                  newWindow.document.body.insertAdjacentHTML(
                                    "afterbegin",
                                    `<div id="print-loader" style="
        position: fixed; inset: 0; z-index: 99999;
        background: rgba(255,255,255,0.92);
        display: flex; flex-direction: column;
        align-items: center; justify-content: center;
        font-family: sans-serif;
      ">
        <div style="
          width: 48px; height: 48px;
          border: 4px solid #e5e7eb;
          border-top-color: #166534;
          border-radius: 50%;
          animation: spin 0.8s linear infinite;
        "></div>
        <p style="margin-top: 16px; color: #374151; font-size: 14px; letter-spacing: 0.05em;">
          Preparing your brochure...
        </p>
        <style>@keyframes spin { to { transform: rotate(360deg); } }</style>
      </div>`,
                                  );

                                  setTimeout(() => {
                                    const loader =
                                      newWindow.document.getElementById(
                                        "print-loader",
                                      );
                                    if (loader) loader.remove();
                                    newWindow.print();
                                  }, 10000);
                                };
                              }}
                              className="px-4 py-1.5 border border-green-800 bg-green-800 hover:bg-white rounded-md hover:text-green-700 text-white hover:dark:text-white hover:scale-105 transition-all duration-200 ease-linear"
                            >
                              <FaDownload size={12} />
                            </button>
                          </td> */}

                          <td>
                            <div className="flex justify-center">
                              <button
                                className="px-2 py-1 text-gray-400 hover:text-black hover:dark:text-white hover:scale-125 transition-all duration-300"
                                // onClick={() => navigate("/")}
                                onClick={() =>
                                  navigate(`/BrochurePDF/${item.id}`)
                                }
                              >
                                <FaEye size={15} />
                              </button>
                              <button
                                className="px-2 py-1 text-gray-400 hover:text-black hover:dark:text-white hover:scale-125 transition-all duration-300"
                                // onClick={() => navigate("/")}
                                onClick={() =>
                                  navigate(`/EditBrochureElementor/${item.id}`)
                                }
                              >
                                <FaEdit size={15} />
                              </button>

                              <button
                                className="px-2 py-1 text-gray-400 hover:text-red-500 hover:dark:text-white hover:scale-125 transition-all duration-300"
                                // onClick={() => navigate("/")}
                                onClick={() => handleDeleteClick(item)}
                                disabled={deletingId === item.id}
                              >
                                {/* villa delete */}
                                {deletingId === item.id ? (
                                  <FaSpinner
                                    className="animate-spin"
                                    size={15}
                                  />
                                ) : (
                                  <MdDelete size={15} />
                                )}
                              </button>
                            </div>
                            {showDeleteModal && selectedBrochure && (
                              <div className="fixed inset-0 bg-black/10 z-50 flex items-center justify-center p-4">
                                <div className="bg-white rounded-lg max-w-md w-full p-6 shadow-xl transform transition-all">
                                  <div className="mb-4">
                                    <h3 className="text-lg font-semibold text-gray-900 mb-2">
                                      Delete Brochure
                                    </h3>
                                    <p className="text-gray-600">
                                      Are you sure you want to delete "
                                      {selectedBrochure.villa_name}"? This
                                      action cannot be undone.
                                    </p>
                                  </div>

                                  <div className="flex justify-end gap-3 mt-6">
                                    <button
                                      onClick={() => {
                                        setShowDeleteModal(false);
                                        setSelectedBrochure(null);
                                      }}
                                      className="px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors duration-200"
                                    >
                                      Cancel
                                    </button>
                                    <button
                                      onClick={confirmDelete}
                                      className="px-4 py-2 text-white bg-red-600 rounded-lg hover:bg-red-700 transition-colors duration-200"
                                    >
                                      Delete
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}

                            {/* Global Loading Overlay for delete operation */}
                            {deletingId && (
                              <div className="fixed inset-0 bg-black/20 z-50 flex items-center justify-center">
                                <div className="bg-white rounded-lg p-8 max-w-sm text-center shadow-2xl">
                                  <div className="mb-4">
                                    <div className="inline-block animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-red-600"></div>
                                  </div>
                                  <h3 className="text-lg font-semibold text-gray-800 mb-2">
                                    Deleting Brochure
                                  </h3>
                                  <p className="text-gray-600 text-sm">
                                    Please wait while we delete the brochure...
                                  </p>
                                </div>
                              </div>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              <nav
                className="flex items-center flex-column flex-wrap md:flex-row justify-between rounded-b-lg px-2 py-1 bg-[#f7f7f7]"
                aria-label="Table navigation"
              >
                <span className="text-xs font-normal text-gray-500 mb-4 md:mb-0 block w-full md:inline md:w-auto">
                  Showing{" "}
                  <span className="font-semibold text-gray-700 dark:text-white">
                    {indexOfFirstTable_brochureVilla + 1}-
                    {Math.min(
                      indexOfLastTable_brochureVilla,
                      filteredBrochures.length,
                    )}
                  </span>{" "}
                  of{" "}
                  <span className="font-semibold text-gray-700 dark:text-white">
                    {filteredBrochures.length}
                  </span>
                </span>

                <ul className="inline-flex -space-x-px rtl:space-x-reverse text-xs h-8">
                  <li>
                    <button
                      onClick={handlePrevPage_brochureVilla}
                      disabled={currentPage_brochureVilla === 1}
                      className="flex items-center justify-center px-1 h-8 ms-0 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 rounded-s-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                    >
                      <MdKeyboardDoubleArrowLeft />
                    </button>
                  </li>
                  {generatePageNumbers_brochureVilla().map((page, index) =>
                    page === "..." ? (
                      <li
                        key={index}
                        className="px-1 h-8 flex items-center justify-center text-gray-500 bg-[#f7f7f7] border-gray-300 dark:text-gray-400 dark:bg-gray-800 dark:border-gray-700"
                      >
                        <span>...</span>
                      </li>
                    ) : (
                      <li key={index}>
                        <button
                          onClick={() => handlePageChange_brochureVilla(page)}
                          className={`flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white ${
                            currentPage_brochureVilla === page
                              ? "text-green-500 underline underline-offset-2"
                              : ""
                          }`}
                        >
                          {page}
                        </button>
                      </li>
                    ),
                  )}
                  <li>
                    <button
                      onClick={handleNextPage_brochureVilla}
                      disabled={
                        currentPage_brochureVilla === totalPages_brochureVilla
                      }
                      className="flex items-center justify-center px-1 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 rounded-e-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                    >
                      <MdKeyboardDoubleArrowRight />
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          )}

          {active === "Hotels" && (
            <div className="shadow-md rounded-lg mt-5">
              <div className="overflow-x-auto">
                <table className="w-full text-sm text-left rtl:text-right text-gray-500">
                  <thead className="text-xs text-gray-400 uppercase bg-green-50 border-b">
                    <tr>
                      <th className="p-4">
                        <input
                          type="checkbox"
                          onChange={handleSelectAll_brochureHotel}
                          checked={
                            selectedRows_brochureHotel.length ===
                              current_brochureHotel.length &&
                            current_brochureHotel.length > 0
                          }
                        />
                      </th>
                      <th className="p-4 w-1/10">Property Name</th>
                      <th className="p-4 w-1/10">Created At</th>
                      <th className="p-4 w-1/10">Updated At</th>
                      {/* <th className="p-4 w-1/10 text-center">
                        Download Brochure
                      </th> */}
                      <th className="p-4 w-1/10 text-center">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {current_brochureHotel.map((table_brochureHotel, index) => {
                      return (
                        <tr
                          key={index}
                          className="bg-white even:bg-gray-50 border-b border-gray-200 hover:bg-gray-100 text-gray-800"
                        >
                          <td className="px-4 py-3">
                            <input
                              type="checkbox"
                              onChange={() =>
                                handleRowCheckboxChange_brochureHotel(
                                  table_brochureHotel.order,
                                )
                              }
                              checked={selectedRows_brochureHotel.includes(
                                table_brochureHotel.order,
                              )}
                            />
                          </td>

                          <td
                            className="px-4 py-3"
                            data-full-content={table_brochureHotel.customer}
                          >
                            <Tooltip
                              title={table_brochureHotel.customer}
                              placement="left"
                            >
                              {table_brochureHotel.customer}
                            </Tooltip>
                          </td>
                          <td className="px-4 py-3">
                            <Tooltip
                              title={table_brochureHotel.productName}
                              placement="left"
                            >
                              {table_brochureHotel.productName}
                            </Tooltip>
                          </td>
                          <td className="px-4 py-3">
                            <Tooltip
                              title={table_brochureHotel.date}
                              placement="left"
                            >
                              {table_brochureHotel.date}
                            </Tooltip>
                          </td>
                          {/* 
                          <td className="px-4 py-3 flex justify-center">
                            <button
                              className="px-4 py-1.5 border border-green-800 bg-green-800 hover:bg-white rounded-md hover:text-green-700 text-white hover:dark:text-white hover:scale-105 transition-all duration-200 ease-linear"
                              // onClick={() => navigate("/")}
                            >
                              <FaDownload size={12} />
                            </button>
                          </td> */}

                          <td>
                            <div className="flex justify-center">
                              <button
                                className="px-2 py-1 text-gray-400 hover:text-black hover:dark:text-white hover:scale-125 transition-all duration-300"
                                // onClick={() => navigate("/")}
                                onClick={() =>
                                  navigate(
                                    active === "Villas"
                                      ? "/BrochureElementor"
                                      : // : "/PropertyBrochure",
                                        "/HotelBrochureElementor",
                                  )
                                }
                              >
                                <FaEye size={15} />
                              </button>

                              <button
                                className="px-2 py-1 text-gray-400 hover:text-red-500 hover:dark:text-white hover:scale-125 transition-all duration-300"
                                // onClick={() => navigate("/")}
                              >
                                <MdDelete size={15} />
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              <nav
                className="flex items-center flex-column flex-wrap md:flex-row justify-between rounded-b-lg px-2 py-1 bg-[#f7f7f7]"
                aria-label="Table navigation"
              >
                <span className="text-xs font-normal text-gray-500 mb-4 md:mb-0 block w-full md:inline md:w-auto">
                  Showing{" "}
                  <span className="font-semibold text-gray-700 dark:text-white">
                    {indexOfFirstTable_brochureHotel + 1}-
                    {Math.min(
                      indexOfLastTable_brochureHotel,
                      table_brochureHotel.length,
                    )}
                  </span>{" "}
                  of{" "}
                  <span className="font-semibold text-gray-700 dark:text-white">
                    {table_brochureHotel.length}
                  </span>
                </span>

                <ul className="inline-flex -space-x-px rtl:space-x-reverse text-xs h-8">
                  <li>
                    <button
                      onClick={handlePrevPage_brochureHotel}
                      disabled={currentPage_brochureHotel === 1}
                      className="flex items-center justify-center px-1 h-8 ms-0 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 rounded-s-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                    >
                      <MdKeyboardDoubleArrowLeft />
                    </button>
                  </li>
                  {generatePageNumbers_brochureHotel().map((page, index) =>
                    page === "..." ? (
                      <li
                        key={index}
                        className="px-1 h-8 flex items-center justify-center text-gray-500 bg-[#f7f7f7] border-gray-300 dark:text-gray-400 dark:bg-gray-800 dark:border-gray-700"
                      >
                        <span>...</span>
                      </li>
                    ) : (
                      <li key={index}>
                        <button
                          onClick={() => handlePageChange_brochureHotel(page)}
                          className={`flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white ${
                            currentPage_brochureHotel === page
                              ? "text-green-500 underline underline-offset-2"
                              : ""
                          }`}
                        >
                          {page}
                        </button>
                      </li>
                    ),
                  )}
                  <li>
                    <button
                      onClick={handleNextPage_brochureHotel}
                      disabled={
                        currentPage_brochureHotel === totalPages_brochureHotel
                      }
                      className="flex items-center justify-center px-1 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 rounded-e-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                    >
                      <MdKeyboardDoubleArrowRight />
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          )}
        </div>
      </main>
    </div>
  );
};

export default PropertyBrochure;
